import MuiSkeleton, { SkeletonProps } from "@mui/material/Skeleton";

export const Skeleton = (props: SkeletonProps) => <MuiSkeleton {...props} />;
